import { z } from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { practiceMemberIdSchema } from './ids';
import {
    NOTES_SETTINGS_TYPE,
    notesSettingsPatchSchema,
    TELEHEALTH_SETTINGS_TYPE,
    telehealthSettingsValueSchema,
} from './practice-member-settings.models';

export const PRACTICE_MEMBER_SETTINGS_UPDATE_TYPE = 'practice-member-settings/update';

// The discriminated union is the registry: sanitizeDataByMetadataFlag resolves the variant by
// `type` before recursing into `value`, so validation and redaction need no separate code.
export const practiceMemberSettingsUpdate = defineCommand(
    PRACTICE_MEMBER_SETTINGS_UPDATE_TYPE,
    z.discriminatedUnion('type', [
        z.object({
            practiceMemberId: practiceMemberIdSchema.meta(metadata.recordId),
            type: z.literal(NOTES_SETTINGS_TYPE),
            value: notesSettingsPatchSchema,
        }),
        // Unlike notes, the write schema is the whole value schema, not `.partial()`: a partial
        // has no meaning for fields that constrain each other, and the UI always submits all three.
        z.object({
            practiceMemberId: practiceMemberIdSchema.meta(metadata.recordId),
            type: z.literal(TELEHEALTH_SETTINGS_TYPE),
            value: telehealthSettingsValueSchema,
        }),
    ]),
);
